/** 依欄位 id 回傳鍵盤類型（web 上對應 input 的 inputMode/type 等），無則回傳 undefined */
export const getKeyboardType = (formItemId: string): "tel" | "text" | "numeric" | "decimal" | "search" | "email" | "url" | "none" | undefined => {
  const phonePadList = ["phoneNumber"]; //-- 建立需要為數字鍵盤 List
  return phonePadList.includes(formItemId) ? "tel" : undefined;
};
